import React from 'react';
import PropTypes from 'prop-types';
import { identity } from 'ramda';
import { FormattedMessage } from 'react-intl';

import { Container, Row, Title, Description } from './ticketCounter.styles';
import { Counter } from '../counter';
import { renderWhenNotNil } from '../../utils/rendering';

export const TicketCounter = ({ className, message, descriptionMessage, onUpdate, value }) => {
  return (
    <Container className={className}>
      <Row>
        <Title>
          <FormattedMessage {...message} />
        </Title>
        <Counter value={value} onUpdate={onUpdate} />
      </Row>
      {renderWhenNotNil(() => (
        <Description>
          <FormattedMessage {...descriptionMessage} />
        </Description>
      ))(descriptionMessage)}
    </Container>
  );
};

TicketCounter.propTypes = {
  value: PropTypes.number,
  className: PropTypes.any,
  message: PropTypes.object.isRequired,
  descriptionMessage: PropTypes.object,
  onUpdate: PropTypes.func,
};

TicketCounter.defaultProps = {
  value: 0,
  onUpdate: identity,
};
